import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import React from "react";
import { useMemorialDiscountCapture } from "@/hooks/useMemorialDiscountCapture";

const RootLayout = () => {
  useMemorialDiscountCapture();

  return (
    <>
      <Helmet>
        <link rel="icon" href="/favicon-blue.ico" />
        <meta name="description" content="SkinnyRx Fitness" />
        <title>SkinnyRx</title>
        {import.meta.env.VITE_DEPLOYMENT === "prod" &&
          navigator.userAgent !== "skinnyrx-autotest" && (
            <script
              type="text/javascript"
              src="//cdn-4.convertexperiments.com/v1/js/100413654-100414852.js?environment=production"
            ></script>
          )}
      </Helmet>
      <Outlet />
    </>
  );
};

export default RootLayout;
